import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LoginManSvg } from "../assets/login_man.svg";
import { ReactComponent as Logo } from "../assets/objects.svg";

const ClaraLanding = () => {
  const navigate = useNavigate();

  const handleEpicLogin = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        bgcolor: "#0e1629",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background ellipses */}
      <div className="ellipse-left"></div>
      <div className="ellipse-right"></div>

      {/* Left Side - Login Form */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: 8,
          zIndex: 1,
        }}
      >
        {/* Logo */}
        <Box sx={{ position: "absolute", top: 32, left: 32, display: "flex", alignItems: "center", gap: 2 }}>
          <Logo width={40} height={40} />
          <Typography variant="h6" fontWeight={600}>Pulse IQ</Typography>
        </Box>

        {/* Login Card */}
        <Box sx={{ maxWidth: 400 }}>
          <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>
            Welcome to CLARA
          </Typography>
          <Typography variant="body1" sx={{ color: "#94A3B8", mb: 4 }}>
            Log in to explore the future of healthcare with AI-driven solutions.
          </Typography>

          {/* Login with Epic Button */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleEpicLogin}
            sx={{
              background: "linear-gradient(103.64deg, #00D173 14.18%, #0BADCE 99.93%)",
              color: "#fff",
              fontSize: "16px",
              fontWeight: 600,
              py: 1.5,
              borderRadius: "8px",
              textTransform: "none",
              boxShadow: "0 4px 20px rgba(0, 209, 115, 0.3)",
              "&:hover": {
                background: "linear-gradient(103.64deg, #00D173 14.18%, #0BADCE 99.93%)",
                boxShadow: "0 6px 24px rgba(0, 209, 115, 0.4)",
              },
            }}
          >
            Login with Epic
          </Button>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            position: "absolute",
            bottom: 24,
            left: 32,
            right: "50%",
            display: "flex",
            justifyContent: "space-between",
            fontSize: "12px",
            color: "#64748B",
          }}
        >
          <Typography variant="caption">TERMS & CONDITIONS</Typography>
          <Typography variant="caption">PRIVACY POLICY</Typography>
          <Typography variant="caption">CONTACT US</Typography>
          <Typography variant="caption">ACCESSIBILITY</Typography>
        </Box>
      </Box>

      {/* Right Side - Illustration */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
        }}
      >
        <LoginManSvg style={{ maxWidth: "80%", height: "auto" }} />
      </Box>

      {/* Copyright */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: 24,
          right: 32,
          color: "#64748B",
          zIndex: 1,
        }}
      >
        © 2025, Pulse IQ Limited. All right reserved.
      </Typography>
    </Box>
  );
};

export default ClaraLanding;
